import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IPbisStatsPeopleResult } from 'libs/domain';
import { ColumnInfo, TemplateColumnKeys, BehaviorReportColumns } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';

import { BHStaffHistoryInfo, BHStaffSummaryInfo } from '../constants';
import { BmReportsService } from './bm-reports.service';

@Injectable()
export class BmReportsStaffDatasourceService extends ReportDatasourceService<IPbisStatsPeopleResult> {
  historyInfo = BHStaffHistoryInfo;
  summaryInfo = BHStaffSummaryInfo;

  constructor(_router: Router, private _bmReports: BmReportsService) {
    super(_router, _bmReports, BmReportsStaffDatasourceService.name);
    const displayCol: ColumnInfo[] = [
      {
        key: TemplateColumnKeys.SUMMARY,
        header: 'Summary',
        columnClasses: ['w-16'],
      },
      {
        key: TemplateColumnKeys.HISTORY,
        header: 'History',
        columnClasses: ['w-16'],
      },
    ];
    super.setDisplayColumns(BehaviorReportColumns.STAFF, displayCol);
  }

  async fetch(offset: number, limit: number) {
    return await this._bmReports.getStaff(offset, limit, this._currentSort);
  }
}
